import {
  STORERANK_DETAIL_PLATFORMS_OPTIONS_PC,
  STORERANK_DETAIL_PLATFORMS_OPTIONS_CONSOLE,
} from '@/pages/intelligence/_config/storeRank/utils';
import { toDateTypeFilter } from '@/pages/intelligence/utils/common';

// 筛选器，所有特殊处理公共文件

// Only OtherVendor MetircList
const ONLYOTHERVENDORMETRICS = [
  'ampere_d1',
  'ampere_d7',
  'ampere_d14',
  'ampere_d28',
  'ampere_d60',
  'ampere_rolling_d1',
  'ampere_rolling_d7',
  'ampere_rolling_d14',
  'ampere_rolling_d28',
  'ampere_rolling_d60',
  'ampere_avg_dailly_playtime',
  'ampere_new_dau',
  'ampere_dau',
  'ampere_mau',
  'ampere_churned_mau',
  'ampere_retained_mau',
  'ampere_new_mau',
  'ampere_added_mau',
  'ampere_previous_mau',
  'ampere_lifetime_users',
  'ampere_stickiness',
  'ampere_acquisition_rate',
  'ampere_avg_monthly_playtime',
];

export const getSpecialMetrictableDevice = (
  value: string[],
  metrics: string[],
  isTrueActiveSegment = false,
) => {
  if (!(Array.isArray(value) && Array.isArray(metrics))) return value;
  const isOnlyOtherVendor =
    Array.isArray(metrics) && metrics?.length > 0
      ? metrics?.every((item) => ONLYOTHERVENDORMETRICS.includes(item))
      : false;
  const valueTemp = isTrueActiveSegment ? ['PC', 'PlayStation', 'Xbox', 'Nintendo'] : [...value];
  const newValue = isOnlyOtherVendor ? valueTemp?.filter((item) => item !== 'Nintendo') : valueTemp;
  return newValue;
};

export const getSpecialMetrictableDeviceOptions = (options: any[], metrics: string[]) => {
  if (!(Array.isArray(options) && Array.isArray(metrics))) return options;
  const isOnlyOtherVendor =
    Array.isArray(metrics) && metrics?.length > 0
      ? metrics?.every((item) => ONLYOTHERVENDORMETRICS.includes(item))
      : false;
  const optionsTemp = [...options];
  const newOptions = optionsTemp?.map((item: any) => {
    return {
      ...item,
      disabled: isOnlyOtherVendor && item?.value === 'Nintendo',
    };
  });
  return newOptions;
};

// 根据是否有pc和console游戏，返回融合游戏storerank详情数据源选项
export const getSpecialComposedSelectParentOptions = (combineConfig: any) => {
  const { hasPc, hasConsole } = combineConfig;
  if (hasPc || hasConsole) {
    return [
      ...(hasPc ? STORERANK_DETAIL_PLATFORMS_OPTIONS_PC : []),
      ...(hasConsole ? STORERANK_DETAIL_PLATFORMS_OPTIONS_CONSOLE : []),
    ];
  }
  return [...STORERANK_DETAIL_PLATFORMS_OPTIONS_PC, ...STORERANK_DETAIL_PLATFORMS_OPTIONS_CONSOLE];
};

// 根据时间继承类型，判断是否需要继承时间
export const isAbleExtendRangeTime = (extendFilterType: string, rangeTimeFilterExtend: any) => {
  // filterKeyMap.RANGE_TIME_EXTEND_TYPE.onlyDate
  if (toDateTypeFilter[extendFilterType] === toDateTypeFilter[rangeTimeFilterExtend?.type]) {
    return true;
  }
  return false;
};
